import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-67ae2f56"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"background-color":"lightblue"} }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Parent component is lightblue", -1))
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }

import {ref} from 'vue';
import childComponent from '../components/EmitsChildComponent.vue'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const text = ref('');
const deletionNotification = ref('');
const deleteNow = (message: string, divisor: number) => {
        const characters = text.value.length
        text.value='';
        deletionNotification.value=`${message}You just deleted all the text with ${divisor} times less characters than ${characters * divisor}`;
        setTimeout(()=> deletionNotification.value = '', 3000)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    (text.value)
      ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(text.value), 1))
      : (_openBlock(), _createElementBlock("p", _hoisted_4, "No text so far")),
    _withDirectives(_createElementVNode("input", {
      type: "text",
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((text).value = $event)),
      placeholder: "enter some text",
      class: "fancy-input"
    }, null, 512), [
      [_vModelText, text.value]
    ]),
    _createVNode(childComponent, { onDeleteText: deleteNow }),
    _createElementVNode("p", null, _toDisplayString(deletionNotification.value), 1)
  ]))
}
}

})